import { render, staticRenderFns } from "./VisitedStores.vue?vue&type=template&id=2b87dc1e&scoped=true&"
import script from "./VisitedStores.vue?vue&type=script&lang=ts&"
export * from "./VisitedStores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87dc1e",
  null
  
)

export default component.exports